export const initialise = () => {
    const page: HTMLBodyElement | null = document.querySelector('.page-job-results')
    if (!page) return;
    moveHeaderToTop(page)
    makeWholeJobTileClickable(page);
}

export const moveHeaderToTop = (page: HTMLElement) => {
    const header: HTMLDivElement | null = page.querySelector('.jobs-widget .attrax-list-widget__tabs')
    const hero: HTMLDivElement | null = page.querySelector('.page-job-results__hero')
    if (!header || !hero) return

    hero.after(header)
}

export const makeWholeJobTileClickable = (page: HTMLBodyElement) => {
    const tiles: NodeListOf<HTMLDivElement> = page.querySelectorAll('.attrax-vacancy-tile')

    tiles.forEach((tile: HTMLDivElement) => {
        const link: HTMLAnchorElement | null = tile.querySelector('.attrax-vacancy-tile__title')
        if (!link) return

        tile.addEventListener('click', (e) => {
            const target = e.target as HTMLElement
            
            if (target.closest('.attrax-vacancy-tile__shortlist')) {
                return
            }
            
            window.location.href = link.href
        })
    })
}